import { createHelpers } from 'vuex-map-fields';


const { getFormBuscarPersonalField, updateFormBuscarPersonalField } = createHelpers({
  getterType: 'getFormBuscarPersonalField',
  mutationType: 'updateFormBuscarPersonalField',
});
export default {
  namespaced: true,
  state: {
    Personal: null,
    Personal_Id: null,
    ListaCargoPersonal: [],
    ListaLicencias: [],
    InputDni: null
  },
  mutations: {
    updateFormBuscarPersonalField
  },
  getters: {
    getFormBuscarPersonalField
  }
};



// WEBPACK FOOTER //
// ./src/store/formbuscarpersonal.js